import { useState, useEffect, useRef } from 'react';

export default function useIntersectionObserver(options = {}) {
  const [isIntersecting, setIsIntersecting] = useState(false);
  const targetRef = useRef();
  const rootRef = useRef();

  useEffect(() => {
    const node = targetRef?.current;
    if (!node) return;
    const intersectionObserverOptions = {
      ...options,
      ...(rootRef?.current && { root: rootRef.current })
    };
    const observer = new IntersectionObserver((entries) => {
      if (entries.length > 0) {
        setIsIntersecting(entries[0].isIntersecting);
      }
    }, intersectionObserverOptions);
    observer.observe(node);
    return () => {
      observer.disconnect();
    };
  }, [options]);

  return {
    isIntersecting,
    rootRef,
    targetRef
  };
}
